module.exports = __webpack_public_path__ + "static/SairaExtraCondensed-ExtraBold-3a8cfbf191664fc4ec14dfe00dd961fc.woff2";